import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inline-date-sections" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_descriptor = _resolveComponent("inline-descriptor")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createVNode(_component_inline_descriptor, {
      ref: "descriptorRef",
      id: _ctx.id,
      "model-value": _ctx.computedModel,
      schema: _ctx.computedSchema,
      separators: _ctx.descriptorSeparators,
      "update-token": _ctx.tokenLimiter,
      editable: _ctx.editable,
      "is-table": false,
      "enable-menu": _ctx.enableMenu,
      "move-to-body": _ctx.moveToBody,
      "menu-z-index": _ctx.menuZIndex,
      "menu-fit-content": true,
      "onUpdate:modelValue": _ctx.onUpdateModelValue,
      onUpdateMenu: _ctx.onUpdateMenu,
      onKeydown: [
        _withKeys(_withModifiers(_ctx.onArrowUp, ["exact","prevent"]), ["up"]),
        _withKeys(_withModifiers(_ctx.onArrowDown, ["exact","prevent"]), ["down"]),
        _withKeys(_withModifiers(_ctx.onEnter, ["exact","prevent"]), ["enter"])
      ]
    }, {
      "menu-content": _withCtx(() => [
        _renderSlot(_ctx.$slots, "menu-content", {}, undefined, true)
      ]),
      _: 3
    }, 8, ["id", "model-value", "schema", "separators", "update-token", "editable", "enable-menu", "move-to-body", "menu-z-index", "onUpdate:modelValue", "onUpdateMenu", "onKeydown"])
  ]))
}